/**
 * Created by Alex Aguilar on 7/26/2016.
 */
(function(){
    'use strict';

    var regulations = {
        templateUrl: 'app/components/checkRegulations/check-regulations.html',
        controller: regulationsController,
        controllerAs: 'vm',
        bindings:{
        }
    };

    angular
        .module('completeAir')
        .component('regulations', regulations);


    function regulationsController(){
        var vm = this;
        vm.regulationsArraySelected = [];

        vm.addToRegulationsArray = function (regulation) {
            vm.regulationsArraySelected.push(regulation);
        }

        vm.deleteFromRegulationsArray = function (regulation) {
            var index = vm.regulationsArraySelected.indexOf(regulation);
            if (index > -1) {
                vm.regulationsArraySelected.splice(index, 1);
            }
        }


        vm.handelCheckBox = function (value, regulation) {
            if(value){
                vm.addToRegulationsArray(regulation);
            }else if(!value){
                vm.deleteFromRegulationsArray(regulation);
            }
        }
    }
})();

